import {ExportReportPayload} from './downloadExportFile'

/** Date fields shared by trip / wallet / gift-card list + export APIs. */
export type AdminDateFilterFields = {
  all_time?: boolean
  preset?: string
  month?: string
  date_from?: string
  date_to?: string
}

export function appendDateFilterToBody(
  body: Record<string, unknown>,
  filter: AdminDateFilterFields
): void {
  if (filter.all_time) {
    body.all_time = true
    return
  }
  if (filter.preset === 'month' && filter.month) {
    body.month = filter.month
    body.date_from = filter.date_from
    body.date_to = filter.date_to
    return
  }
  if (filter.date_from) body.date_from = filter.date_from
  if (filter.date_to) body.date_to = filter.date_to
}

export function appendDateFilterToExport(
  payload: ExportReportPayload,
  filter: AdminDateFilterFields
): void {
  if (filter.all_time) {
    payload.all_time = true
    return
  }
  if (filter.preset === 'month' && filter.month) {
    payload.month = filter.month
    payload.date_from = filter.date_from
    payload.date_to = filter.date_to
    return
  }
  if (filter.date_from) payload.date_from = filter.date_from
  if (filter.date_to) payload.date_to = filter.date_to
}
